<template>
  <div v-if="!loadPage">
    <luma-datatable :model="taskModel"
                    :columns="columns"
                    :url="urlC">
    </luma-datatable>
  </div>
</template>

<script>
    import {VserverTasks} from "@/store/models/vserver/vserver_tasks";
    import LumaDatatable from "@/components/LumaDatatable";
    import DatePicker from 'v-calendar/lib/components/date-picker.umd'
    export default {
        components: {LumaDatatable,DatePicker},
        name: "luma-tasks-vserver",
        props:{loadPage:Boolean},
        data:()=>({
          taskModel:VserverTasks
        }),
          computed:{
            vid(){
                return this.$route.params.id
            },
          urlC(){
            return "/datacenter/vservers/"+this.vid+"/tasks"
            },

          columns(){
              return [
                {
                  key:'start_time',
                  column:'start_time',
                  filter:true,
                  order:true
                },
                {
                  key:'end_time',
                  column:'end_time',
                  filter:true,
                  order:true
                },
                {
                  key:'state',
                  column:'state',
                  filter:true,
                  order:true
                },
                {
                  key:'type',
                  column:'type',
                  filter:true,
                  order:true
                }
                ]
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-tasks-vserver.vue